import React, {Fragment, type RefObject} from "react";
import {scroller} from "react-scroll";
import cn from "classnames";
import type {Property} from "csstype";

import {capitalize, noop} from "@pg-mono/nodash";

import type {ITab} from "../types/ITab";
import type {TabsActiveColor} from "../types/TabsActiveColor";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsTheme} from "../types/TabsTheme";
import type {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

export type IProps<ValueType extends TabsAllowedValueTypes> = {
    activeColor?: TabsActiveColor;
    className?: string;
    fullWidth?: boolean;
    fullWidthBorder?: boolean;
    onChange?: (value: ValueType) => void;
    tabs: ITab<ValueType>[];
    titleClassName?: string;
    titlesMaxWidth?: Property.MaxWidth;
    theme?: TabsTheme;
    value?: ValueType;
    variant?: TabsVariant;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
};

type ClassName = keyof typeof styles;

const getTilesVariant = (variant: TabsVariant) => `tiles${capitalize(variant)}` as ClassName;
const getFullWidthBorder = (color: TabsActiveColor) => `tabsFullWidthBorder${colorToClassName(color)}` as ClassName;

export const Tabs = <ValueType extends TabsAllowedValueTypes>(props: IProps<ValueType>) => {
    const {
        theme = "gray",
        variant = "contained",
        tabs,
        activeColor,
        className,
        customRenderer,
        fullWidth,
        fullWidthBorder,
        onChange,
        titleClassName,
        titlesMaxWidth,
        value
    } = props;

    const onClick = (value: ValueType, scrollRef?: RefObject<HTMLElement>, scrollId?: string, scrollOffset?: number) => {
        onChange?.(value);

        if (scrollId && scrollOffset) {
            scroller.scrollTo(scrollId, {offset: scrollOffset, smooth: true});
        }

        if (scrollRef && scrollRef.current) {
            scrollRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
        }
    };

    const classes = cn(styles.tabs, fullWidthBorder && styles.tabsFullWidthBorder, styles[getFullWidthBorder(activeColor || theme)], className);

    return (
        <div className={classes}>
            <div style={titlesMaxWidth ? {maxWidth: titlesMaxWidth} : noop()}>
                <div className={cn(styles.tiles, fullWidth && styles.wFull, styles[getTilesVariant(variant)])}>
                    {tabs.map((tab, index) => {
                        const active = typeof value !== "undefined" ? value === tab.value : false;

                        const titleElement = (
                            <Title
                                key={tab.value}
                                active={active}
                                activeColor={props.activeColor}
                                className={titleClassName}
                                dataTestId={tab.dataTestId}
                                fullWidth={props.fullWidth}
                                onClick={() => onClick(tab.value, tab.scrollRef, tab.scrollId, tab.scrollOffset)}
                                theme={theme}
                                variant={variant}
                            >
                                {tab.title}
                            </Title>
                        );

                        return customRenderer ? customRenderer(tab, titleElement, index) : titleElement;
                    })}
                </div>
            </div>

            {tabs.map((tab) => {
                return value === tab.value ? <Fragment key={`tc${tab.value}`}>{tab.content}</Fragment> : null;
            })}
        </div>
    );
};
import React, {Fragment, type RefObject} from "react";
import {scroller} from "react-scroll";
import cn from "classnames";
import type {Property} from "csstype";

import {capitalize, noop} from "@pg-mono/nodash";

import type {ITab} from "../types/ITab";
import type {TabsActiveColor} from "../types/TabsActiveColor";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsTheme} from "../types/TabsTheme";
import type {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

export type IProps<ValueType extends TabsAllowedValueTypes> = {
    activeColor?: TabsActiveColor;
    className?: string;
    fullWidth?: boolean;
    fullWidthBorder?: boolean;
    onChange?: (value: ValueType) => void;
    tabs: ITab<ValueType>[];
    titleClassName?: string;
    titlesMaxWidth?: Property.MaxWidth;
    theme?: TabsTheme;
    value?: ValueType;
    variant?: TabsVariant;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
};

type ClassName = keyof typeof styles;

const getTilesVariant = (variant: TabsVariant) => `tiles${capitalize(variant)}` as ClassName;
const getFullWidthBorder = (color: TabsActiveColor) => `tabsFullWidthBorder${colorToClassName(color)}` as ClassName;

export const Tabs = <ValueType extends TabsAllowedValueTypes>(props: IProps<ValueType>) => {
    const {
        theme = "gray",
        variant = "contained",
        tabs,
        activeColor,
        className,
        customRenderer,
        fullWidth,
        fullWidthBorder,
        onChange,
        titleClassName,
        titlesMaxWidth,
        value
    } = props;

    const onClick = (value: ValueType, scrollRef?: RefObject<HTMLElement>, scrollId?: string, scrollOffset?: number) => {
        onChange?.(value);

        if (scrollId && scrollOffset) {
            scroller.scrollTo(scrollId, {offset: scrollOffset, smooth: true});
        }

        if (scrollRef && scrollRef.current) {
            scrollRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
        }
    };

    const classes = cn(styles.tabs, fullWidthBorder && styles.tabsFullWidthBorder, styles[getFullWidthBorder(activeColor || theme)], className);

    return (
        <div className={classes}>
            <div style={titlesMaxWidth ? {maxWidth: titlesMaxWidth} : noop()}>
                <div className={cn(styles.tiles, fullWidth && styles.wFull, styles[getTilesVariant(variant)])}>
                    {tabs.map((tab, index) => {
                        const active = typeof value !== "undefined" ? value === tab.value : false;

                        const titleElement = (
                            <Title
                                key={tab.value}
                                active={active}
                                activeColor={props.activeColor}
                                className={titleClassName}
                                dataTestId={tab.dataTestId}
                                fullWidth={props.fullWidth}
                                onClick={() => onClick(tab.value, tab.scrollRef, tab.scrollId, tab.scrollOffset)}
                                theme={theme}
                                variant={variant}
                            >
                                {tab.title}
                            </Title>
                        );

                        return customRenderer ? customRenderer(tab, titleElement, index) : titleElement;
                    })}
                </div>
            </div>

            {tabs.map((tab) => {
                return value === tab.value ? <Fragment key={`tc${tab.value}`}>{tab.content}</Fragment> : null;
            })}
        </div>
    );
};
